import React from 'react';
import InfoGrid from "../../../../../../components/info-grid/info-grid.jsx";

const OccurrenceLinks = ({data}) => {
    const links = data.links ?? []
    if (!links.length || !links) return null;

    return (
        <>
            { links && (
                <section className="space-y-4! px-5!">
                    { links.map((item, index) => {

                        const info = [
                            {
                                label: "Descrição",
                                value: item?.description ?? ""
                            },
                            {
                                label: "Link",
                                value: item?.link ?? "",
                                span: 2
                            }
                        ];

                        return (
                            <>
                                <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid! mb-2">
                                    LINK - {index + 1}
                                </h2>

                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default OccurrenceLinks;